import * as Yup from "yup";

export const searchUserToSendAddRequestVal = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First name too short")
    .max(50, "First name too long")
    .required("First name is required"),
  lastName: Yup.string()
    .min(2, "Last name too short")
    .max(50, "Last name too long")
    .required("Last name is required"),
  middleName: Yup.string()
    .min(2, "Middle name too short")
    .max(50, "Middle name too long")
    .optional()
    .nullable(),
  email: Yup.string().email("Invalid email").required("Required"),
  phone: Yup.object({
    countryCode: Yup.string().nullable(),
    number: Yup.string().nullable(),
  })
    .nullable()
    .optional(),
});

export const validateViewAndSearchAddRequestSendOut = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First name too short")
    .max(50, "First name too long"),
  lastName: Yup.string()
    .min(2, "Last name too short")
    .max(50, "Last name too long"),
  email: Yup.string().email("Invalid email"),
});
